import EventBusyIcon from '@mui/icons-material/EventBusy';
import { styled } from '@mui/material/styles';

const StyledErrorIcon = styled(EventBusyIcon)(({ theme }) => ({
  fontSize: '7rem',
  color: theme.palette.primary.main
}));

export default StyledErrorIcon;
